// Local translations
export const T = {
  en_GB: {
    description: "Define custom fields to capture additional information on client records.",
    addCustomField: "Add Custom Field",
  },
  nb_NO: {
    description: "Definer egendefinerte felt for å registrere tilleggsinformasjon om kunder.",
    addCustomField: "Legg til egendefinert felt",
  },
} as const;
